import ServicePage from './page';
import { groupHealthInsuranceData } from '@/mocks/servicePagesBatch2';

export default function GroupHealthInsurancePage() {
  return <ServicePage data={groupHealthInsuranceData} />;
}